export const nettoyageExpress = [
  {
    id: 'express-ext',
    category: 'Express',
    name: 'Express Extérieur',
    description: 'Lavage + jantes + vitres ext + finition pneus',
    prices: [
      { size: 'Citadine/Compact', duration: '30 min', price: 70 },
      { size: 'Berline/Break', duration: '35 min', price: 70 },
      { size: 'SUV', duration: '40 min', price: 70 },
      { size: 'SUV 7 places', duration: '45 min', price: 70 },
    ],
  },
  {
    id: 'express-int',
    category: 'Express',
    name: 'Express Intérieur',
    description: 'Aspiration + surfaces + vitres int',
    prices: [
      { size: 'Citadine/Compact', duration: '45 min', price: 89 },
      { size: 'Berline/Break', duration: '50 min', price: 99 },
      { size: 'SUV', duration: '55 min', price: 109 },
      { size: 'SUV 7 places', duration: '60 min', price: 119 },
    ],
  },
  {
    id: 'express-complet',
    category: 'Express',
    name: 'Express Intérieur + Extérieur',
    description: 'Nettoyage complet express',
    prices: [
      { size: 'Citadine/Compact', duration: '1h15', price: 149 },
      { size: 'Berline/Break', duration: '1h25', price: 169 },
      { size: 'SUV', duration: '1h35', price: 189 },
      { size: 'SUV 7 places', duration: '1h45', price: 209 },
    ],
  },
];

export const nettoyageApprofondi = [
  {
    id: 'approfondi-ext',
    category: 'Approfondi',
    name: 'Approfondi Extérieur',
    description: 'Lavage + jantes + décontamination légère + séchage soigné',
    prices: [
      { size: 'Citadine/Compact', duration: '45 min', price: 100 },
      { size: 'Berline/Break', duration: '55 min', price: 100 },
      { size: 'SUV', duration: '1h05', price: 100 },
      { size: 'SUV 7 places', duration: '1h15', price: 100 },
    ],
  },
  {
    id: 'approfondi-int',
    category: 'Approfondi',
    name: 'Approfondi Intérieur',
    description: 'Shampouinage tissus/moquettes + détails',
    prices: [
      { size: 'Citadine/Compact', duration: '1h30', price: 179 },
      { size: 'Berline/Break', duration: '1h45', price: 199 },
      { size: 'SUV', duration: '2h00', price: 229 },
      { size: 'SUV 7 places', duration: '2h15', price: 249 },
    ],
  },
  {
    id: 'approfondi-complet',
    category: 'Approfondi',
    name: 'Approfondi Intérieur + Extérieur',
    description: 'Nettoyage complet approfondi',
    prices: [
      { size: 'Citadine/Compact', duration: '2h30', price: 279 },
      { size: 'Berline/Break', duration: '2h50', price: 309 },
      { size: 'SUV', duration: '3h15', price: 349 },
      { size: 'SUV 7 places', duration: '3h30', price: 399 },
    ],
  },
];

export const nettoyageSupreme = [
  {
    id: 'supreme',
    category: 'Suprême',
    name: 'Nettoyage Suprême',
    description: 'Int/ext complet + textiles + détails + protection',
    prices: [
      { size: 'Citadine/Compact', duration: '5h', price: 549 },
      { size: 'Berline/Break', duration: '6h', price: 649 },
      { size: 'SUV', duration: '7h', price: 749 },
      { size: 'SUV 7 places', duration: '8h', price: 849 },
    ],
  },
];

export const cielEtoile = [
  {
    id: 'ciel-200',
    category: 'Ciel Étoilé',
    name: 'Ciel Étoilé 200 étoiles',
    description: 'Installation de 200 fibres optiques pour un ciel étoilé personnalisé',
    stars: 200,
    duration: '2h30',
    price: 195,
    depositRequired: true,
    depositPercentage: 30,
  },
  {
    id: 'ciel-300',
    category: 'Ciel Étoilé',
    name: 'Ciel Étoilé 300 étoiles',
    description: 'Installation de 300 fibres optiques pour un ciel étoilé personnalisé',
    stars: 300,
    duration: '3h30',
    price: 325,
    depositRequired: true,
    depositPercentage: 30,
  },
  {
    id: 'ciel-400',
    category: 'Ciel Étoilé',
    name: 'Ciel Étoilé 400 étoiles',
    description: 'Installation de 400 fibres optiques pour un ciel étoilé personnalisé',
    stars: 400,
    duration: '4h30',
    price: 455,
    depositRequired: true,
    depositPercentage: 30,
  },
  {
    id: 'ciel-500',
    category: 'Ciel Étoilé',
    name: 'Ciel Étoilé 500 étoiles',
    description: 'Installation de 500 fibres optiques pour un ciel étoilé personnalisé',
    stars: 500,
    duration: '5h30',
    price: 585,
    depositRequired: true,
    depositPercentage: 30,
  },
  {
    id: 'ciel-600',
    category: 'Ciel Étoilé',
    name: 'Ciel Étoilé 600 étoiles',
    description: 'Installation de 600 fibres optiques pour un ciel étoilé personnalisé',
    stars: 600,
    duration: '6h30',
    price: 689,
    depositRequired: true,
    depositPercentage: 30,
  },
  {
    id: 'ciel-700',
    category: 'Ciel Étoilé',
    name: 'Ciel Étoilé 700 étoiles',
    description: 'Installation de 700 fibres optiques pour un ciel étoilé personnalisé',
    stars: 700,
    duration: '7h30',
    price: 832,
    depositRequired: true,
    depositPercentage: 30,
  },
  {
    id: 'ciel-800',
    category: 'Ciel Étoilé',
    name: 'Ciel Étoilé 800 étoiles',
    description: 'Installation de 800 fibres optiques pour un ciel étoilé personnalisé',
    stars: 800,
    duration: '8h30',
    price: 910,
    depositRequired: true,
    depositPercentage: 30,
  },
  {
    id: 'ciel-900',
    category: 'Ciel Étoilé',
    name: 'Ciel Étoilé 900 étoiles',
    description: 'Installation de 900 fibres optiques pour un ciel étoilé personnalisé',
    stars: 900,
    duration: '9h30',
    price: 1079,
    depositRequired: true,
    depositPercentage: 30,
  },
];

export const polishCorrection = [
  {
    id: 'lustrage',
    category: 'Polish',
    name: 'Lustrage 1 étape',
    description: 'Pour voiture récente, gain de brillance + finition',
    prices: [
      { size: 'Citadine/Compact', duration: '2h', price: 299 },
      { size: 'Berline/Break', duration: '2h30', price: 349 },
      { size: 'SUV', duration: '3h', price: 449 },
      { size: 'SUV 7 places', duration: '3h30', price: 499 },
    ],
  },
  {
    id: 'polissage-1',
    category: 'Polish',
    name: 'Polissage 1 étape',
    description: 'Pour défauts visibles, amélioration nette',
    prices: [
      { size: 'Citadine/Compact', duration: '5h', price: 499 },
      { size: 'Berline/Break', duration: '6h', price: 699 },
      { size: 'SUV', duration: '8h', price: 999 },
      { size: 'SUV 7 places', duration: '9h', price: 1099 },
    ],
  },
  {
    id: 'polissage-2',
    category: 'Polish',
    name: 'Polissage 2 étapes',
    description: 'Résultat quasi neuf, teintes foncées',
    prices: [
      { size: 'Citadine/Compact', duration: '9h', price: 899 },
      { size: 'Berline/Break', duration: '11h', price: 1199 },
      { size: 'SUV', duration: '14h', price: 1599 },
      { size: 'SUV 7 places', duration: '16h', price: 1799 },
    ],
  },
];

export const ceramiquePacksComplets = [
  {
    id: 'pack-ceramique-1an',
    category: 'Céramique',
    name: 'Pack Complet 1 an',
    description: 'Carrosserie + vitres + 4 jantes — Lavage, décontamination, lustrage et pose céramique',
    badge: 'Économisez jusqu\'à 600 CHF',
    prices: [
      { size: 'Citadine/Compact', duration: '10h', price: 1210 },
      { size: 'Berline/Break', duration: '12h', price: 1500 },
      { size: 'SUV / 4x4', duration: '14h', price: 1900 },
      { size: 'SUV 7 places', duration: '15h', price: 2100 },
    ],
  },
  {
    id: 'pack-ceramique-3ans',
    category: 'Céramique',
    name: 'Pack Complet 3 ans',
    description: 'Carrosserie + vitres + 4 jantes — Lavage, décontamination, lustrage et pose céramique',
    badge: 'Populaire',
    prices: [
      { size: 'Citadine/Compact', duration: '10h', price: 1430 },
      { size: 'Berline/Break', duration: '12h', price: 1700 },
      { size: 'SUV / 4x4', duration: '14h', price: 2100 },
      { size: 'SUV 7 places', duration: '15h', price: 2300 },
    ],
  },
  {
    id: 'pack-ceramique-5ans',
    category: 'Céramique',
    name: 'Pack Complet 5 ans',
    description: 'Carrosserie + vitres + 4 jantes — Lavage, décontamination, lustrage et pose céramique',
    badge: 'Recommandé',
    prices: [
      { size: 'Citadine/Compact', duration: '14h', price: 1760 },
      { size: 'Berline/Break', duration: '16h', price: 2000 },
      { size: 'SUV / 4x4', duration: '18h', price: 2400 },
      { size: 'SUV 7 places', duration: '19h', price: 2600 },
    ],
  },
  {
    id: 'pack-ceramique-7ans',
    category: 'Céramique',
    name: 'Pack Complet 7 ans',
    description: 'Carrosserie + vitres + 4 jantes — Lavage, décontamination, lustrage et pose céramique',
    badge: 'Premium',
    prices: [
      { size: 'Citadine/Compact', duration: '18h', price: 2310 },
      { size: 'Berline/Break', duration: '20h', price: 2500 },
      { size: 'SUV / 4x4', duration: '23h', price: 2900 },
      { size: 'SUV 7 places', duration: '25h', price: 3100 },
    ],
  },
];

export const ceramiqueIndividuel = [
  {
    id: 'ceramique-carrosserie-1an',
    category: 'Céramique',
    name: 'Céramique Carrosserie 1 an',
    description: 'Lavage + décontamination + lustrage + pose céramique carrosserie uniquement',
    prices: [
      { size: 'Citadine/Compact', duration: '7h', price: 770 },
      { size: 'Berline/Break', duration: '8h', price: 1100 },
      { size: 'SUV / 4x4', duration: '10h', price: 1500 },
      { size: 'SUV 7 places', duration: '11h', price: 1700 },
    ],
  },
  {
    id: 'ceramique-carrosserie-3ans',
    category: 'Céramique',
    name: 'Céramique Carrosserie 3 ans',
    description: 'Lavage + décontamination + lustrage + pose céramique carrosserie uniquement',
    prices: [
      { size: 'Citadine/Compact', duration: '7h', price: 990 },
      { size: 'Berline/Break', duration: '8h', price: 1300 },
      { size: 'SUV / 4x4', duration: '10h', price: 1700 },
      { size: 'SUV 7 places', duration: '11h', price: 1900 },
    ],
  },
  {
    id: 'ceramique-carrosserie-5ans',
    category: 'Céramique',
    name: 'Céramique Carrosserie 5 ans',
    description: 'Lavage + décontamination + lustrage + pose céramique carrosserie uniquement',
    prices: [
      { size: 'Citadine/Compact', duration: '10h', price: 1320 },
      { size: 'Berline/Break', duration: '12h', price: 1600 },
      { size: 'SUV / 4x4', duration: '14h', price: 2000 },
      { size: 'SUV 7 places', duration: '15h', price: 2200 },
    ],
  },
  {
    id: 'ceramique-carrosserie-7ans',
    category: 'Céramique',
    name: 'Céramique Carrosserie 7 ans',
    description: 'Lavage + décontamination + lustrage + pose céramique carrosserie uniquement',
    prices: [
      { size: 'Citadine/Compact', duration: '14h', price: 1870 },
      { size: 'Berline/Break', duration: '16h', price: 2100 },
      { size: 'SUV / 4x4', duration: '19h', price: 2500 },
      { size: 'SUV 7 places', duration: '21h', price: 2700 },
    ],
  },
  {
    id: 'ceramique-vitres',
    category: 'Céramique',
    name: 'Céramique Vitres',
    description: 'Protection céramique sur toutes les vitres du véhicule',
    price: 200,
    duration: '1h30',
  },
  {
    id: 'ceramique-jantes-4',
    category: 'Céramique',
    name: 'Céramique 4 Jantes',
    description: 'Protection céramique sur les 4 jantes',
    price: 400,
    duration: '2h30',
  },
  {
    id: 'ceramique-jante-unite',
    category: 'Céramique',
    name: 'Céramique Jante à l\'unité',
    description: 'Protection céramique par jante',
    price: 100,
    duration: '30 min',
  },
  {
    id: 'ceramique-plastiques-int',
    category: 'Céramique',
    name: 'Céramique Plastiques intérieurs',
    description: 'Protection céramique des plastiques intérieurs',
    price: 99,
    duration: '1h',
  },
  {
    id: 'ceramique-cuir',
    category: 'Céramique',
    name: 'Céramique Cuir intérieur',
    description: 'Protection céramique du cuir intérieur',
    price: 99,
    duration: '1h30',
  },
];

// Keep old exports for backward compatibility with prestations page
export const ceramiqueCarrosserie = [
  {
    id: 'ceramique-1an',
    category: 'Céramique',
    name: 'Pack Céramique 1 an',
    description: 'Lavage + décontamination + lustrage + pose',
    prices: [
      { size: 'Citadine/Compact', duration: '7h', price: 770 },
      { size: 'Berline/Break', duration: '8h', price: 1100 },
      { size: 'SUV / 4x4', duration: '10h', price: 1500 },
      { size: 'SUV 7 places', duration: '11h', price: 1700 },
    ],
  },
  {
    id: 'ceramique-3ans',
    category: 'Céramique',
    name: 'Pack Céramique 3 ans',
    description: 'Lavage + décontamination + lustrage + pose',
    prices: [
      { size: 'Citadine/Compact', duration: '7h', price: 990 },
      { size: 'Berline/Break', duration: '8h', price: 1300 },
      { size: 'SUV / 4x4', duration: '10h', price: 1700 },
      { size: 'SUV 7 places', duration: '11h', price: 1900 },
    ],
  },
  {
    id: 'ceramique-5ans',
    category: 'Céramique',
    name: 'Pack Céramique 5 ans',
    description: 'Lavage + décontamination + lustrage + pose',
    prices: [
      { size: 'Citadine/Compact', duration: '10h', price: 1320 },
      { size: 'Berline/Break', duration: '12h', price: 1600 },
      { size: 'SUV / 4x4', duration: '14h', price: 2000 },
      { size: 'SUV 7 places', duration: '15h', price: 2200 },
    ],
  },
  {
    id: 'ceramique-7ans',
    category: 'Céramique',
    name: 'Pack Céramique 7 ans',
    description: 'Lavage + décontamination + lustrage + pose',
    prices: [
      { size: 'Citadine/Compact', duration: '14h', price: 1870 },
      { size: 'Berline/Break', duration: '16h', price: 2100 },
      { size: 'SUV / 4x4', duration: '19h', price: 2500 },
      { size: 'SUV 7 places', duration: '21h', price: 2700 },
    ],
  },
];

export const ceramiqueOptions = [
  {
    id: 'ceramique-vitres',
    name: 'Céramique vitres',
    description: 'Toutes vitres',
    duration: '1h30',
    price: 200,
  },
  {
    id: 'ceramique-jantes',
    name: 'Céramique jantes',
    description: '4 jantes',
    duration: '2h30',
    price: 400,
  },
  {
    id: 'ceramique-jante-unite',
    name: 'Céramique jante à l\'unité',
    description: 'Par jante',
    duration: '30 min',
    price: 100,
    priceLabel: 'dès 100 CHF / jante',
  },
  {
    id: 'ceramique-plastiques',
    name: 'Céramique plastiques extérieurs',
    description: 'Protection plastiques',
    duration: '1h',
    price: 99,
    priceLabel: 'dès 99 CHF',
  },
  {
    id: 'ceramique-cuir',
    name: 'Céramique cuir',
    description: 'Protection cuir intérieur',
    duration: '1h30',
    price: 99,
    priceLabel: 'dès 99 CHF',
  },
];

export const supplements = [
  {
    id: 'poils-animaux',
    name: 'Poils d\'animaux',
    icon: 'ri-bear-smile-line',
    price: 40,
    description: 'Élimination complète des poils d\'animaux',
  },
  {
    id: 'vehicule-sale',
    name: 'Véhicule très sale / sable / boue',
    icon: 'ri-water-flash-line',
    price: 75,
    description: 'Nettoyage intensif pour véhicule très sale',
  },
  {
    id: 'desinfection',
    name: 'Désinfection / ozone',
    icon: 'ri-shield-check-line',
    price: 49,
    description: 'Traitement désinfectant complet',
  },
  {
    id: 'coffre-charge',
    name: 'Coffre très chargé / démontage sièges bébé',
    icon: 'ri-luggage-cart-line',
    price: 30,
    description: 'Démontage et remontage des équipements',
  },
];

export const serviceDomicile = [
  {
    id: 'domicile-0-10',
    distance: '0-10 km',
    price: 29,
  },
  {
    id: 'domicile-10-20',
    distance: '10-20 km',
    price: 49,
  },
  {
    id: 'domicile-plus',
    distance: 'Au-delà de 20 km',
    priceLabel: '+ 2 CHF/km',
  },
];
